export default function OrderButton(props: { onClick: () => void }) {
  return (
    <div className="flex flex-row items-center justify-center px-10 mt-2 pt-3 border-t border-[#E6E6E6]">
      <button
        onClick={props.onClick}
        className="w-full h-10 max-w-sm px-4 py-2 text-white bg-green-700 rounded-2xl hover:bg-green-800 hover:font-medium"
        aria-label="Odeslat objednávku"
      >
        Odeslat objednávku
      </button>
    </div>
  )
}
